<div class="organization-modal modal-content" piqetAngularDraggable>
  <div class="modal-header header-modal">
    <span class="bootstrap-dialog-title">Packaging contents configuration </span>
    <button type="button" class="closeModal pull-right" (click)="onClose()" aria-label="Close">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>

  <div class="modal-body body-modal">
    <div class="row">
      <form [formGroup]="reportConfigForm">
        <div class="col-12 custom-margin">
          <label *ngIf="reportConfigForm.get('contents')?.value" class="sub-header-drpdown pb-2"
            >Selected packaging contents estimate data</label
          >
          <ng-select
            [clearable]="true"
            [clearOnBackspace]="false"
            #contents
            [items]="reportConfigData?.productList"
            formControlName="contents"
            [searchable]="false"
            bindLabel="name"
            placeholder="Select packaging contents estimate data"
            (change)="selectedPackage($event)"
          >
            <ng-template ng-header-tmp>
              <div class="has-feedback">
                <input
                  type="text"
                  class="form-control accordion-search search-input"
                  id="inputValidation"
                  placeholder="Search..."
                  (input)="contents.filter($any($event.target).value)"
                />
                <span class="form-control-feedback">
                  <i class="fa fa-search"></i>
                </span>
              </div>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
              <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
            </ng-template>
          </ng-select>
          <div
            *ngIf="
              (submitted || reportConfigForm.controls['contents']?.touched) &&
              reportConfigForm.controls['contents']?.invalid
            "
            class="input-error"
          >
            Content is required.
          </div>
        </div>

        <div class="col-12 custom-margin">
          <div class="form-group required" aria-required="true">
            <div class="services-form">
              <input
                formControlName="mass"
                type="number"
                placeholder="Mass volume in retail pack"
              />
              <label>Mass/volume in retail pack</label>
            </div>
          </div>
        </div>

        <div class="col-12 custom-margin">
          <div class="required" aria-required="true">
            <div class="services-form">
              <input
                formControlName="funcUnit"
                type="number"
                placeholder="Functional unit multiplier"
              />
              <label>Functional unit multiplier</label>
            </div>
          </div>
          <div
            *ngIf="
              (submitted || reportConfigForm.controls['funcUnit']?.touched) &&
              reportConfigForm.controls['funcUnit']?.invalid
            "
            class="input-error"
          >
            Functional unit multiplier is required.
          </div>
          <div
            *ngIf="
              (submitted || reportConfigForm.controls['funcUnit']?.touched) &&
              reportConfigForm.controls['funcUnit']?.value <= 0
            "
            class="input-error"
          >
            Functional unit multiplier can't be zero.
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-light cancel-btn modelBtn" (click)="onClose()">
      Cancel
    </button>
    <button type="button" class="modelBtn purpleBtnHoverEffect" (click)="onSave()">Save</button>
  </div>
</div>
